import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'lassi-root',
  template: `<router-outlet></router-outlet>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor() {
    const domSanitizer = inject(DomSanitizer);
    const icons = ['google_maps', 'victoria', 'drag_zoom_in', 'drag_zoom_out'];

    const registry = inject(MatIconRegistry).setDefaultFontSetClass(
      'material-symbols-outlined',
    );
    for (const icon of icons) {
      registry.addSvgIcon(
        icon,
        domSanitizer.bypassSecurityTrustResourceUrl(
          `/assets/icons/${icon}.svg`,
        ),
      );
    }
  }
}
